import { ReactQueryDevtoolsPanel } from "@tanstack/react-query-devtools";

export default {
	name: "Tanstack Query",
	render: <ReactQueryDevtoolsPanel />,
};
